import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ToasterMode } from '@creditsights/styleguide-web';
import { updateDocketAlertPreferences } from '../../services/docketAlerts/docketAlerts.service';
import { useToast } from '../toast/useToast';
import { GENERIC_ERROR_TEXT } from '../../Base.constants';
import { Preference, UpdateDocketAlertPreferencesArgs } from '../../models/DocketAlerts';

const useUpdateDocketAlertPreferences = (): UseMutationResult<Preference, Error, UpdateDocketAlertPreferencesArgs> => {
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  const mutation = useMutation<Preference, Error, UpdateDocketAlertPreferencesArgs>(
    (args: UpdateDocketAlertPreferencesArgs) => updateDocketAlertPreferences(args),
    {
      onSuccess: () => {
        showToast('Docket alert updated.');
        queryClient.invalidateQueries('docketAlertPreferences');
      },
      onError: (error) => {
        console.error('Error updating preferences:', error);
        showToast(GENERIC_ERROR_TEXT, ToasterMode.ERROR);
      },
    }
  );
  return mutation;
};

export default useUpdateDocketAlertPreferences;
